import { gql } from "@apollo/client";

export const UPDATE_MEMBERSHIP_VIDEO_MUTATION = gql`
  mutation UpdateMembershipVideo($input: BackofficeUpdateMembershipVideoInput!) {
    updateMembershipVideo(videoInput: $input) {
      message
      success
    }
  }
`;

const MEMBERSHIP_VIDEO_CORE_FIELDS = `
  id
  title
  url
  description
  series
  publishedAt
  expiredAt
  creditCategory
  durationInSeconds
  assessment {
    id
    questions {
      id
      content
      position
      options {
        id
        content
        answer
        position
      }
    }
  }
`;

/**
 * Identity fields needed even when backoffice-scorm-courses is off so deep links
 * and list→detail navigation can recognize SCORM and stay read-only. Status/launch
 * fields stay on the flag-on document only.
 */
const MEMBERSHIP_VIDEO_SCORM_IDENTITY_FIELDS = `
  contentType
  creditAmount
`;

const MEMBERSHIP_VIDEO_SCORM_STATUS_FIELDS = `
  scormStatus
  scormStatusMessage
  scormLaunchUrl
`;

/**
 * Flag-off detail query. Selects SCORM identity without status/launch fields so
 * schema-sensitive status fields stay flag-gated while contentType still drives
 * the read-only gate.
 */
export const GET_MEMBERSHIP_VIDEO_QUERY = gql`
  query GetMembershipVideos(
    $searchTerm: String
    $creditCategories: [MembershipCreditCategory!]
    $stages: [String!]
    $series: [String!]
    $orderBy: [BackofficeMembershipVideoOrderByInput!]
  ) {
    membershipVideos(
      searchTerm: $searchTerm
      creditCategories: $creditCategories
      stages: $stages
      series: $series
      orderBy: $orderBy
    ) {
      nodes {
        ${MEMBERSHIP_VIDEO_CORE_FIELDS}
        ${MEMBERSHIP_VIDEO_SCORM_IDENTITY_FIELDS}
      }
    }
  }
`;

/**
 * SCORM-enriched detail query. Used when backoffice-scorm-courses is on so deep
 * links (no location.state.video) can load status/launch fields.
 */
export const GET_MEMBERSHIP_VIDEO_WITH_SCORM_QUERY = gql`
  query GetMembershipVideosWithScorm(
    $searchTerm: String
    $creditCategories: [MembershipCreditCategory!]
    $stages: [String!]
    $series: [String!]
    $orderBy: [BackofficeMembershipVideoOrderByInput!]
  ) {
    membershipVideos(
      searchTerm: $searchTerm
      creditCategories: $creditCategories
      stages: $stages
      series: $series
      orderBy: $orderBy
    ) {
      nodes {
        ${MEMBERSHIP_VIDEO_CORE_FIELDS}
        ${MEMBERSHIP_VIDEO_SCORM_IDENTITY_FIELDS}
        ${MEMBERSHIP_VIDEO_SCORM_STATUS_FIELDS}
      }
    }
  }
`;
